/**
 * Barra de avance de la galería de la PDP (Figma 30:26 desktop / 14:5454 mobile).
 *
 * El Figma pone bajo la galería una barra de 4px: carril gris claro a todo el ancho y
 * pulgar en violeta proporcional al número de imágenes. El theme no tiene nada parecido:
 * `snippets/product-media-gallery.liquid` no emite contador ni dots.
 *
 * SE INYECTA DESDE JS en vez de añadir el markup al snippet a propósito. Toda la PDP del
 * rediseño vive en archivos propios (`pdp-*.liquid`, `pdp-*.js`, `pdp-figma.css`)
 * justamente para que una actualización del theme, que sí pisa `snippets/` y `sections/`,
 * no se lleve el diseño por delante. Meter el markup en el snippet compartido rompería
 * esa regla por un elemento puramente decorativo.
 *
 * DOS MODOS, PORQUE LA GALERÍA SE COMPORTA DISTINTO SEGÚN EL ANCHO:
 * - En mobile la lista de medios es un carrusel con scroll horizontal real, así que la
 *   barra se calcula del scroll y sigue el dedo de forma continua.
 * - En desktop, con `gallery_layout: thumbnail_slider`, la lista NO scrollea: el theme
 *   enseña solo la diapositiva activa y las demás quedan ocultas. Ahí el scroll siempre
 *   mide cero y la barra tiene que salir del índice de la diapositiva activa.
 * La elección se hace en cada recálculo, no una sola vez, porque el usuario puede rotar
 * el dispositivo o cambiar el tamaño de la ventana.
 */
(function () {
  'use strict';

  if (window.pdpGalleryProgressReady) return;
  window.pdpGalleryProgressReady = true;

  var LIST_SELECTOR = 'ul.product__media-list';
  var ITEM_SELECTOR = 'li.product-media-item';

  /**
   * Diapositivas que CUENTAN para la barra.
   *
   * No vale mirar cuáles se ven: a partir de 750px el theme deja visible solo la activa
   * (section-main-product.css:1289, `.product--thumbnail_slider .product-media-item:not(.is-active) { display: none }`),
   * así que contar por visibilidad daba 1 sola diapositiva en escritorio y la barra se
   * escondía sola por creer que no había nada que recorrer.
   *
   * Lo único que hay que descontar son las diapositivas duplicadas por variante, que
   * section-main-product.css:1336 oculta salvo la primera. Se replica ese mismo criterio.
   */
  function countableItems(list) {
    var items = list.querySelectorAll(ITEM_SELECTOR);
    var countable = [];
    for (var i = 0; i < items.length; i++) {
      if (i > 0 && items[i].classList.contains('product-media-item--variant')) continue;
      countable.push(items[i]);
    }
    return countable;
  }

  function update(bar) {
    var list = bar.pdpList;
    if (!list) return;

    var scrollable = list.scrollWidth - list.clientWidth > 1;
    var width;
    var left;

    if (scrollable) {
      width = list.clientWidth / list.scrollWidth;
      left = list.scrollLeft / list.scrollWidth;
    } else {
      var items = countableItems(list);
      if (items.length < 2) {
        bar.hidden = true;
        return;
      }
      var index = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-active')) {
          index = i;
          break;
        }
      }
      width = 1 / items.length;
      left = index / items.length;
    }

    if (width >= 1) {
      bar.hidden = true;
      return;
    }

    bar.hidden = false;
    bar.pdpThumb.style.width = width * 100 + '%';
    // `left` en vez de `transform` porque el ancho del pulgar es relativo al carril y un
    // `translateX` porcentual se mediría contra el propio pulgar, no contra el carril.
    bar.pdpThumb.style.left = left * 100 + '%';
  }

  function schedule(bar) {
    if (bar.pdpQueued) return;
    bar.pdpQueued = true;
    window.requestAnimationFrame(function () {
      bar.pdpQueued = false;
      update(bar);
    });
  }

  function attach(list) {
    if (list.pdpProgressReady) return;
    list.pdpProgressReady = true;

    var bar = document.createElement('div');
    bar.className = 'pdp-gallery-progress';
    bar.setAttribute('aria-hidden', 'true');

    var thumb = document.createElement('span');
    thumb.className = 'pdp-gallery-progress__thumb';
    bar.appendChild(thumb);

    bar.pdpList = list;
    bar.pdpThumb = thumb;

    list.parentNode.insertBefore(bar, list.nextSibling);

    list.addEventListener('scroll', function () {
      schedule(bar);
    });
    window.addEventListener('resize', function () {
      schedule(bar);
    });

    // El theme mueve la clase `is-active` entre diapositivas al pulsar una miniatura o
    // las flechas. No emite ningún evento al hacerlo, así que la única forma de enterarse
    // es observar el atributo.
    //
    // Aquí se llama a `update` DIRECTAMENTE y no a `schedule`: cambiar de diapositiva es
    // un gesto puntual del usuario, no un torrente como el scroll, así que no hay nada
    // que agrupar — y coalescer en un requestAnimationFrame haría que la barra dependa
    // de que el navegador programe un frame. La referencia al observer se guarda en el
    // propio elemento para que no pueda recogerla el GC.
    if (window.MutationObserver) {
      bar.pdpObserver = new MutationObserver(function () {
        update(bar);
      });
      bar.pdpObserver.observe(list, { attributes: true, attributeFilter: ['class'], subtree: true });
    }

    update(bar);
  }

  function scan() {
    var lists = document.querySelectorAll(LIST_SELECTOR);
    for (var i = 0; i < lists.length; i++) {
      // La galería a pantalla completa reutiliza el mismo markup; ahí la barra sobra.
      if (lists[i].closest('.product-media-modal')) continue;
      attach(lists[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Las imágenes cargan en diferido: hasta que no tienen alto, `scrollWidth` miente.
  window.addEventListener('load', scan);
})();
